"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServdErrors = void 0;
var ServdError = /** @class */ (function () {
    function ServdError(_a) {
        var errorCode = _a.errorCode, message = _a.message;
        this.errorCode = errorCode;
        this.message = message;
    }
    return ServdError;
}());
var ServdErrors = /** @class */ (function () {
    // private to disallow creating other instances of this type
    function ServdErrors(key, value) {
        this.key = key;
        this.value = value;
    }
    ServdErrors.prototype.toString = function () {
        return this.key;
    };
    ServdErrors.PRODUCT_EXISTS_IN_MENU = new ServdError({ errorCode: "9001", message: "Cannot delete products that exist in a menu" });
    return ServdErrors;
}());
exports.ServdErrors = ServdErrors;
